function EULA() {
  return (
    <>
      <section className=" cont-form">
        <div className="container px-0">
          <div className="row privacy">
            <div className="row align-items-center text-center">
              <div className="col-12 ">
                <h1>Cloudlas Apps - End User License Agreement</h1>
              </div>
            </div>

            <div className="col-sm-12 col-lg-12 priv-cont px-0">
              <div className="row">
                <div className="section-heading">
                  <div className="col-md-12 policiesStyle policyFont">
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This end
                      user license terms are an agreement between you and
                      Cloudlas Solutions LLP also known as Cloudlas. Please read
                      them. They apply to the add-in, connector or other
                      software application you download from the Office Store or
                      acquire from within the settings of an Office product
                      (“App”), unless the App comes with separate terms
                      (“Third-Party License”). If so, the terms of the
                      Third-Party License will apply. This agreement also
                      applies to any updates and supplements for the App, unless
                      other terms accompany those items. If so, those terms
                      apply.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span className="themeColor">
                      <strong>
                        BY DOWNLOADING, INSTALLING, OR USING THE APP, OR
                        ATTEMPTING TO DO ANY OF THESE, YOU HAVE ACCEPTED THESE
                        TERMS. IF YOU DO NOT INTEND TO ACCEPT THEM, YOU HAVE NO
                        RIGHT TO (AND MUST NOT) DOWNLOAD OR USE THE APP.
                      </strong>
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Except for the above, if the App enables access to any
                      Internet-based services, your use of those services will
                      be subject to the separately-provided terms of use.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      If you comply with these license terms, you have the
                      rights below.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      <ul>
                        <li>
                          <strong className="themeColor">
                            INSTALLATION AND USE RIGHTS -
                          </strong>
                          You may install and use the App on a Windows device or
                          devices that are affiliated with the Microsoft account
                          that you use to access the Office Store or Office
                          product. You may not install or use a copy of the App
                          on a device you do not own or control.
                        </li>
                        <li>
                          <strong className="themeColor">
                            INTERNET-BASED SERVICES -
                          </strong>
                          Cloudlas may provide Internet-based services with the
                          App. In addition to the following, your use of those
                          services is subject to the terms provided to you by
                          Cloudlas and/or your wireless carrier.
                          <div
                            style={{ marginLeft: "2em" }}
                            className="policySubText"
                          >
                            <ul>
                              <li>
                                <strong className="themeColor">
                                  Consent for Internet-Based or Wireless
                                  Services -
                                </strong>
                                The App may connect to computer systems over an
                                Internet-based and/or wireless network. In some
                                cases, you will not receive a separate notice
                                when they connect. Using the App operates as
                                your consent to the transmission of standard
                                device information (including but not limited to
                                technical information about your device, system
                                and App software, and peripherals) for
                                Internet-based and/or wireless services.
                              </li>
                              <li>
                                <strong className="themeColor">
                                  Misuse of Internet-based Services -
                                </strong>
                                You may not use any Internet-based service in
                                any way that could harm it or impair anyone
                                else’s use of it or the wireless network. You
                                also may not use any Internet-based service to
                                try to gain unauthorized access to any service,
                                data, account, or network by any means.
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li>
                          <strong className="themeColor">
                            SCOPE OF LICENSE -{" "}
                          </strong>
                          The App is licensed, not sold. This agreement only
                          gives you some rights to use the App. The App Provider
                          reserves all other rights. Unless the law gives you
                          more rights despite this limitation, you may use the
                          App only as expressly permitted in this agreement. In
                          doing so, you must comply with any technical
                          limitations in the App that only allow you to use it
                          in certain ways. You may not:
                          <div
                            style={{ marginLeft: "2em" }}
                            className="policySubText"
                          >
                            <ul>
                              <li>
                                work around any technical limitations in the App
                              </li>
                              <li>
                                reverse engineer, decompile, or disassemble the
                                App, except and only to the extent that the law
                                expressly permits, despite this limitation
                              </li>
                              <li>
                                make more copies of the App than specified in
                                this agreement or allowed by the law, despite
                                this limitation
                              </li>
                              <li>
                                publish or otherwise make the App available for
                                others to copy; or rent, lease or lend the App
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li>
                          <strong className="themeColor">
                            DOCUMENTATION -{" "}
                          </strong>
                          If documentation is provided with the App, you may
                          copy and use the documentation solely for your
                          reference purposes.
                        </li>
                        <li>
                          <strong className="themeColor">
                            TECHNOLOGY AND EXPORT RESTRICTIONS -
                          </strong>
                          The App may be subject to United States or
                          international technology control or export laws and
                          regulations. You must comply with all domestic and
                          international laws and regulations that apply to the
                          technology used, employed or supported by the App.
                          These laws include restrictions on destinations, end
                          users and end use. For information on how these laws
                          and regulations apply to Microsoft-branded products,
                          see&nbsp;
                          <a
                            href="https://www.microsoft.com/exporting"
                            target="_blank"
                          >
                            www.microsoft.com/exporting
                          </a>
                          .
                        </li>
                        <li>
                          <strong className="themeColor">
                            APPLICABLE LAW -{" "}
                          </strong>
                          The laws of the country apply where the app is
                          acquired or used in.
                        </li>
                        <li>
                          <strong className="themeColor">
                            LEGAL EFFECT -{" "}
                          </strong>
                          This agreement describes certain legal rights. You may
                          have other rights under the laws of the state or
                          country where you reside. This agreement does not
                          change your rights under the laws of the state or
                          country where you reside if such laws do not permit it
                          to do so.
                        </li>
                        <li>
                          DISCLAIMER OF WARRANTY. THE APP IS LICENSED "AS-IS,"
                          "WITH ALL FAULTS," AND "AS AVAILABLE." YOU BEAR ALL
                          RISK OF USING IT. THE APP PROVIDER, ON BEHALF OF
                          ITSELF, MICROSOFT, WIRELESS CARRIERS OVER WHOSE
                          NETWORK THE APP IS DISTRIBUTED, AND ITS AND THEIR
                          RESPECTIVE AFFILIATES, VENDORS, AGENTS, AND SUPPLIERS
                          (“DISTRIBUTORS”), GIVES NO EXPRESS WARRANTIES,
                          GUARANTEES, OR CONDITIONS UNDER OR IN RELATION TO THE
                          APP. YOU MAY HAVE ADDITIONAL CONSUMER RIGHTS UNDER
                          YOUR LOCAL LAWS WHICH THIS AGREEMENT CANNOT CHANGE. TO
                          THE EXTENT PERMITTED UNDER YOUR LOCAL LAWS,
                          DISTRIBUTORS EXCLUDE ANY IMPLIED WARRANTIES OR
                          CONDITIONS, INCLUDING THOSE OF MERCHANTABILITY,
                          FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
                        </li>
                        <li>
                          LIMITATION ON AND EXCLUSION OF REMEDIES AND DAMAGES.
                          TO THE EXTENT NOT PROHIBITED BY LAW, YOU CAN RECOVER
                          FROM THE APP PROVIDER ONLY DIRECT DAMAGES UP TO THE
                          AMOUNT YOU PAID FOR THE APP. YOU AGREE NOT TO SEEK TO
                          RECOVER ANY OTHER DAMAGES, INCLUDING CONSEQUENTIAL,
                          LOST PROFITS, SPECIAL, INDIRECT OR INCIDENTAL DAMAGES
                          FROM ANY DISTRIBUTOR. <br />
                          <div
                            style={{ marginLeft: "2em" }}
                            className="policySubText"
                          >
                            <br />
                            This limitation applies to
                            <ul>
                              <li>
                                anything related to the App, services made
                                available through the App, or content (including
                                code) on third-party Internet sites; and
                              </li>
                              <li>
                                claims for breach of contract; breach of
                                warranty, guarantee or condition; or strict
                                liability, negligence, or other tort to the
                                extent permitted by applicable law.
                              </li>
                              <br />
                              It also applies even if
                              <br />
                              <li>
                                repair, replacement, or a refund for the App
                                does not fully compensate you for any losses; or
                              </li>
                              <li>
                                Distributor knew or should have known about the
                                possibility of the damages.
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EULA;
